import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TicketSubjectsModal from "../ticket-module/components/TicketSubjectsModal";

export default function TicketSettingsPage() {
  const navigate = useNavigate();
  const [showSubjects, setShowSubjects] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  return (
    <div style={{ padding: isMobile ? "16px 12px" : "24px", maxWidth: 1000, margin: "0 auto" }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
        <button
          onClick={() => navigate("/destek")}
          title="Destek sayfasına dön"
          style={{ width: 38, height: 38, borderRadius: 10, border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
        >
          <i className="bi bi-arrow-left"></i>
        </button>
        <div style={{ minWidth: 0 }}>
          <h4 style={{ fontWeight: 800, color: "#111827", margin: 0 }}>
            <i className="bi bi-gear-fill me-2 text-primary"></i>Ticket Ayarları
          </h4>
          <p style={{ color: "#6b7280", fontSize: "0.85rem", margin: "4px 0 0" }}>
            Destek sisteminin genel ayarlarını buradan yönetin.
          </p>
        </div>
      </div>

      {/* Ayar kartları */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 14 }}>
        <button
          onClick={() => setShowSubjects(true)}
          style={{
            textAlign: "left", background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 16,
            padding: "18px", cursor: "pointer", display: "flex", alignItems: "flex-start", gap: 14,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)", transition: "box-shadow 0.15s, border-color 0.15s",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#a5b4fc"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(99,102,241,0.15)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e5e7eb"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)"; }}
        >
          <div style={{ width: 44, height: 44, borderRadius: 12, background: "linear-gradient(135deg,#6366f1,#4f46e5)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <i className="bi bi-tags-fill" style={{ fontSize: "1.1rem" }}></i>
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: "0.95rem", color: "#111827" }}>Ticket Konuları</div>
            <div style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: 3, lineHeight: 1.45 }}>
              Ticket açılırken seçilen konuları görüntüleyin ve yeni konu ekleyin.
            </div>
          </div>
        </button>
      </div>

      {showSubjects && <TicketSubjectsModal onClose={() => setShowSubjects(false)} />}
    </div>
  );
}
